const tr = {
    "1": "Kişisel Bilgiler",
    "2": "Kullanıcı Bilgileri",
    "3": "Kullanıcı adı",
    "4": "Ad Soyad",
    "5": "Eposta",
    "6": "Şifre Değiştir",
    "7": "Şifre",
    "8": "Yeni Şifre",
    "9": "Yeni Şifre (Tekrar)",
    "10": "Şifre Değiştir",
    "11": "Müşteriler",
    "12": "Müşteri Ekle",
    "13": "Erkek",
    "14": "Kadın",
    "15": "Beyan etmek istemiyorum",
    "16": "İsim",
    "17": "Soyisim",
    "18": "Doğum Tarihi",
    "19": "Şifre",
    "20": "Ekle",
    "21": "Bakiye",
    "22": "Son Giriş Tarih",
    "23": "Yatırım",
    "24": "Çekim",
    "25": "Kuponlar",
    "26": "No",
    "27": "Durum",
    "28": "Tutar",
    "29": "Kazanç",
    "30": "Tarih",
    "31": "Raporlar",
    "32": "Göster",
    "33": "Müşteri kaydı bulunmamaktadır!",
    "34": "Kupon bulunmamaktadır!",
    "35": "Bayi Bilgileri",
    "36": "Kalan Limit",
    "37": "Bayi Adresi",
    "38": "Spor",
    "39": "Komisyonlar",
    "40": "Poker",
    "41": "Bayi Paneli",
    "42": "Giriş",
    "43": "Almış olduğunuz bonus dolayısıyla oyuna giriş yapamazsınız!",
    "44": "Hemen Oyna",
    "45": "Para Yatırma",
    "46": "Para yatırım işleminiz bize ulaşmıştır. En kısa sürede hesabınıza yüklenecektir.",
    "47": "İşlem Ücreti",
    "48": "İşlem Süresi",
    "49": "İşlem Limitleri",
    "50": "Banka",
    "51": "Müşteri Notu",
    "52": "Onayla",
    "53": "Gönderen Numara",
    "54": "Alıcı Numara",
    "55": "Kontrol et",
    "56": "Bitcoin Adres",
    "57": "Dogecoin Adres",
    "58": "Litecoin Adres",
    "59": "Talep Gönder",
    "60": "Casino Geçmişi",
    "61": "Henüz herhangi bir casino oyun kaydı bulunmamaktadır!",
    "62": "Oyun",
    "63": "Kupon Geçmişi",
    "64": "Henüz yapılmış bir kupon kaydınız bulunmamaktadır!",
    "65": "Finans Geçmişi",
    "66": "Henüz herhangi bir işlem kaydı bulunmamaktadır!",
    "67": "Tip",
    "68": "Beklemede",
    "69": "Onaylandı",
    "70": "İptal Edildi",
    "71": "Para Çekme",
    "72": "Sonuç Bekliyor",
    "73": "Kaybetti",
    "74": "Kazandı",
    "75": "Bu ayrıcalığı yaşamak için hemen ",
    "76": "Hemen üye ol",
    "77": "Spor Bahisi Limitleri",
    "78": "Minimum Yatırım",
    "79": "Maksimum Yatırım",
    "80": "Maksimum Kazanç",
    "81": "Günlük Oynama Limiti",
    "82": "Limitler",
    "83": "Kupon",
    "84": "Casino için almış olduğunuz bonusdan dolayı bahis yapamazsınız!",
    "85": "Mobil Keyfi",
    "86": "Sade ve şık tasarımıyla kullanıcılarına anında bahis yapma veya casino oynama imkanını sunan , internet bağlantısı olan her yerde bahis ve casinonun tadına varacaksın.",
    "87": "Anında Üyelik",
    "88": "Canlı",
    "89": "Casino",
    "90": "spor ve canlı bahisler, canlı casino ve yüzlerce slot, diğer bütün işlemler mobil de tek tuşla!",
    "91": "Kimlik No",
    "92": "Cep Telefonu",
    "93": "Şehir",
    "94": "Adres",
    "95": "Şifre (Tekrar)",
    "96": "Eposta (Tekrar)",
    "97": "istiyorum!",
    "98": "Bonus istemiyorum!",
    "99": "Promosyonlar",
    "100": "Bu kutuyu işaretleyerek, <a class=\"active\" target=\"_blank\" href=\"/page/termsconditions\">Genel Kurallar ve Şartları</a> okuduğumu ve kabul ettiğimi beyan ederim.",
    "101": "Üye Ol",
    "102": "Yukarıda verdiğim bilgilerin doğru olduğunu kabul ediyorum.",
    "103": "Slot arama",
    "104": "Ülke seçiniz",
    "105": "Kategoriler",
    "106": "Arama",
    "107": "Takım adı...",
    "108": "Popüler Ligler",
    "109": "Bir daha gösterme!",
    "110": "Beni Hatırla",
    "111": "Kayıt Ol",
    "112": "Spor",
    "113": "Canlı",
    "114": "Casino",
    "115": "Slot",
    "117": "Bonuslar",
    "118": "Çıkış yap",
    "119": "Kayıt",
    "120": "Hesabım",
    "121": "Giriş",
    "122": "Mobil",
    "123": "Bonus",
    "124": "Merhaba",
    "125": "Başlayan canlı maç karşılaşması bulunmamaktadır!",
    "126": "Canlı",
    "127": "İsabetli Şut",
    "128": "İsabetsiz Şut",
    "129": "Toplam Atak",
    "130": "Tehlikeli Atak",
    "131": "Kupon oluşturmak için giriş yapmanız gerekmektedir!",
    "132": "Kupon bulunamadı!",
    "133": "Karşılaşma",
    "134": "Bahis",
    "135": "Oran",
    "136": "Kupon Tutarı",
    "137": "Toplam Kazanç",
    "138": "Karşılaşmalar",
    "139": "Yaklaşan Karşılaşmalar",
    "140": "Kuponunuzda değişen veya kaldırılan oran bulunmaktadır!",
    "141": "Kupon oluşturmak için bahis seçimini yapınız!",
    "142": "Toplam",
    "143": "Müşteri",
    "144": "Toplam Bahis",
    "145": "Tutarınız 0'dan büyük olması gerekmektedir!",
    "146": "Çekim yapmak istediğiniz tutar müşteri bakiyesinden düşüktür!",
    "147": "Limitinizden fazla para eklemesi yapamazsınız! Kalan limitiniz:",
    "148": "Lütfen tüm alanları doldurunuz!",
    "149": "Şifreniz 8-256 karakter olmalıdır. Büyük/küçük harf, rakam veya sembol zorunluluğu yoktur.",
    "150": "Geçersiz eposta adresi yazdınız!",
    "151": "Bu bilgilere benzer kayıt bulunuyor!",
    "152": "Mevcut şifrenizi yanlış yazdınız!",
    "153": "Hatalı kullanıcı adı veya şifre!",
    "154": "Bekleyen bir finansal işleminiz var iken para çekimi yapamazsınız. Lütfen sonuçlanmasını bekleyin!",
    "155": "Çekim yapmak istediğiniz tutar bakiyenizden düşüktür!",
    "156": "IBAN ve Hesap numarası boş olamaz!",
    "157": "Hesap numarası boş olamaz!",
    "158": "Minimum çekim tutarından daha az çekemezsiniz!",
    "159": "Maksimum çekim tutarından daha fazla çekemezsiniz!",
    "160": "Hesabınıza tanımlı bonus olduğu için çekim talebi veremezsiniz!",
    "161": "Bekleyen bir finansal işleminiz var iken para yatırımı yapamazsınız. Lütfen sonuçlanmasını bekleyin!",
    "162": "Cepbank bilgileri boş olamaz!",
    "163": "Minimum yatırım tutarından daha az yatıramazsınız!",
    "164": "Maksimum yatırım tutarından daha fazla yatıramazsınız!",
    "165": "Kupon oluşturabilmek için öncelikle giriş yapmanız gerekmektedir!",
    "166": "Oran değişiklerini kabul ediyorum!",
    "167": "Onayla",
    "168": "Temizle",
    "169": "Kuponunuz yatırılmaktadır. Onaylıyor musunuz?",
    "170": "Evet",
    "171": "Hayır",
    "172": "Ocak",
    "173": "Şubat",
    "174": "Mart",
    "175": "Nisan",
    "176": "Mayıs",
    "177": "Haziran",
    "178": "Temmuz",
    "179": "Ağustos",
    "180": "Eylül",
    "181": "Ekim",
    "182": "Kasım",
    "183": "Aralık",
    "184": "Kupon tutarı için bakiyeniz yeterli değildir!",
    "185": "Günlük kupon oynama limitiniz yetersiz!",
    "186": "Lütfen en az bir karşılaşma ekleyiniz!",
    "187": "Kuponunuzda kaldırılan bir oran tipi bulunmaktadır!",
    "188": "Kuponunuzda kaldırılan bir lig bulunmaktadır!",
    "189": "Kuponunuzda kaldırılan bir ülke bulunmaktadır!",
    "190": "Kuponunuzda kaldırılan bir spor bulunmaktadır!",
    "191": "Bonus kuralları gereği kuponuzun toplam oranı minimum orandan daha az olamaz!",
    "192": "Kuponunuzda değişen veya kaldırılan canlı maç oranı bulunmaktadır!",
    "193": "Kuponunuzda biten veya fikstür den kaldırılan karşılaşma bulunmaktadır!",
    "194": "Kupon tutarınız minimum ile maksimum tutar arasında olması gerekmektedir!",
    "195": "Maksimum bahis limiti!",
    "196": "Şifre ve şifre tekrarınız aynı değil!",
    "197": "Eposta ve eposta tekrarınız aynı değil!",
    "198": "Hatalı bir TC kimlik numarası yazdınız! Lütfen adınız, soyadınızı ve doğum tarihinizi doğru ve isminizde türkçe karakter var ise büyük harfle yazmaya özen gösteriniz!",
    "199": "Kimlik no alanı boş geçilemez!",
    "200": "Kuralları okuduğunuz kabul etmeniz gerekiyor!",
    "201": "Eposta adresi, kullanıcı adı veya TC Kimlik no ile kayıtlı üye bulunuyor!",
    "202": "Ev Sahibi / Ev Sahibi",
    "203": "Ev Sahibi / Beraberlik",
    "204": "Ev Sahibi / Deplasman",
    "205": "Beraberlik / Ev Sahibi",
    "206": "Beraberlik / Beraberlik",
    "207": "Beraberlik / Deplasman",
    "208": "Deplasman / Ev Sahibi",
    "209": "Deplasman / Beraberlik",
    "210": "Deplasman / Deplasman",
    "211": "Ev Sahibi",
    "212": "Beraberlik",
    "213": "Deplasman",
    "214": "Ev Sahibi veya Beraberlik",
    "215": "Ev Sahibi veya Deplasman",
    "216": "Deplasman veya Beraberlik",
    "217": "Üst",
    "218": "Alt",
    "219": "Gol",
    "220": "Hızlı Yatırım",
    "221": "Tek",
    "222": "Çift",
    "223": "1. yarı",
    "224": "2. yarı",
    "225": "1. Gol Yok",
    "226": "2. Gol Yok",
    "227": "3. Gol Yok",
    "228": "4. Gol Yok",
    "229": "5. Gol Yok",
    "230": "6. Gol Yok",
    "231": "7. Gol Yok",
    "232": "8. Gol Yok",
    "233": "9. Gol Yok",
    "234": "10. Gol Yok",
    "235": "Tam Sayı",
    "236": "Gol Yok",
    "237": "IBAN",
    "238": "1. Set",
    "239": "2. Set",
    "240": "3. Set",
    "241": "4. Set",
    "242": "5. Set",
    "243": "1. Yarı",
    "244": "2. Yarı",
    "245": "1. Çeyrek",
    "246": "2. Çeyrek",
    "247": "3. Çeyrek",
    "248": "4. Çeyrek",
    "249": "Uzatmalar",
    "250": " veya ",
    "251": "Çekim talebiniz tarafımıza ulaşmıştır.",
    "252": "Şube Kodu",
    "253": "Hesap No",
    "254": "En Son Kazananlar",
    "255": "Kupon Detayı",
    "256": "Yüksek Oranlar",
    "257": "Skor",
    "258": "Hesap kilitli!",
    "259": "Anasayfa",
    "260": "Kar",
    "261": "Sistem Bildirimi",
    "262": "Lütfen seçiminizi kombine kupon olarak tekrar deneyiniz",
    "263": "Lütfen seçiminizi tekli kupon olarak tekrar deneyiniz",
    "264": "Casino giriş yetkiniz bulunmamaktadır!",
    "265": "Slot giriş yetkiniz bulunmamaktadır!",
    "267": "Yatırım talebi gönderme yetkiniz bulunmamaktadır!",
    "268": "Çekim talebi gönderme yetkiniz bulunmamaktadır!",
    "269": "Kayıt Tarih",
    "270": "Son Giriş Tarih",
    "271": "Yeni Müşteriler",
    "272": "Tekli",
    "273": "Kombine",
    "274": "Hatalı bir telefon numarası girdiniz!",
    "275": "Hatalı bir TC kimlik numarası girdiniz!",
    "276": "Eposta adresi ile kayıtlı üye bulunamadı!",
    "277": "Futbol",
    "278": "Basketbol",
    "279": "Tenis",
    "280": "Voleybol",
    "281": "Tombala",
    "282": "Şifremi Unuttum",
    "283": "Şifre değiştirme bağlantısı epostanıza gönderildi.",
    "284": "İşlem Geçmişi",
    "285": "Sonuç bulunamadı!",
    "286": "Geri dön",
    "287": "Hepsi",
    "288": "Favorilerim",
    "289": "Maç Sonucu",
    "290": "1. Devre",
    "291": "2. Devre",
    "292": "Kapat",
    "293": "Başvuru talebiniz bize ulaşmıştır. En kısa sürede yetkili personel size dönüş yapacaktır.",
    "294": "18 yaşından küçükler kayıt olamamaktadır!",
    "295": "Hatalı bir doğum tarihi formatı girdiniz! (Örnek 25/08/1980)",
    "296": "Güvenli olmayan bir internet bağlantınız mevcut. Lütfen farklı bir internet ile deneyiniz.",
    "297": "Daha önce bonus aldığınız için tekrar alamazsınız!",
    "298": "Başvuru talebiniz daha önce alınmıştır!",
    "299": "Casino oyunları için önce giriş yapmanız gerekmektedir!",
    "300": "Eposta adresine kayıtlı hesap bulunamadı!",
    "301": "Hatalı şifre değiştirme bağlantısı",
    "302": "Yeni şifre ve şifre tekrarınız aynı değil!",
    "303": "Mevcut şifreniz hatalı",
    "304": "Bakiyeniz kupon tutarı için uygun değil",
    "305": "Kuponunuzda aktif olmayan bahisler var",
    "306": "Bahis alabilmeniz için giriş yapmanız gerekiyor",
    "307": "Kuponu kaydetmek için önce bahis yapmanız gerekiyor",
    "308": "Lütfen seçiminizi kombine kupon olarak tekrar deneyiniz!",
    "309": "Lütfen seçiminizi kombine kupon olarak tekrar deneyiniz.",
    "310": "Casino bonusu aldığınızdan bahis yapamazsınız",
    "311": "Bonus kuralları gereği minimum oranınız yeterli değil",
    "312": "Mevcut olmayan oran tipine bahis yapamazsınız",
    "313": "Mevcut olmayan lige bahis yapamazsınız",
    "314": "Mevcut olmayan ülkeye bahis yapamazsınız",
    "315": "Mevcut olmayan spor tipine bahis yapamazsınız",
    "316": "Mevcut olmayan karşılaşmaya bahis yapamazsınız",
    "317": "Minimum tekli oran limiti uygun değil",
    "318": "Minimum kombine oran limiti uygun değil",
    "319": "Minimum kombine için oran limiti uygun değil",
    "320": "Maksimum kombine bahis limitini aştınız",
    "321": "Minimum kupon tutarınız uygun değil",
    "322": "Maksimum kupon tutarınız uygun değil",
    "323": "Oran tipi limiti uygun değil",
    "324": "Lig limiti uygun değil",
    "325": "Karşılaşma limiti uygun değil",
    "326": "Karşılaşma bahis yapmak için uygun değil",
    "327": "Oranlar değişti güncel oranlar kabul etmeniz gerekiyor!",
    "328": "Maç Öncesi",
    "329": "Sadece son 100 kuponu görüntüleyebilirsiniz.",
    "330": "Sadece son 100 kaydı görüntüleyebilirsiniz.",
    "331": "Önceki",
    "332": "Sonraki",
    "333": "Maksimum kazanç limiti uygun değil!",
    "334": "Şifreniz değiştirildi",
    "335": "Değiştir",
    "336": "Sağlayıcılar",
    "338": "Gönder",
    "339": "Bekleyen",
    "340": "Kaybeden",
    "341": "Kazanan",
    "342": "İptal",
    "343": "",
    "344": "",
    "345": "Hemen Üye Ol",
    "346": "Reklamları Al",
    "347": "Tanıtıma Başla",
    "348": "Para Kazan",
    "349": "",
    "350": "Bayi Kayıt",
    "351": "Bayilik",
    "352": "Cinsiyet",
    "353": "dakika",
    "354": "saat",
    "355": "Yazdır",
    "356": "Kuponunuz başarılı bir şekilde kaydedildi",
    "357": "Gizle",
    "358": "Oranlar kapalı",
    "359": "Bahis servisi şuan aktif değildir!",
    "360": "Casino servisi şuan aktif değildir!",
    "361": "Slot servisi şuan aktif değildir!",
    "362": "Bugün",
    "363": "Yarın",
    "364": "Para Yatır",
    "365": "Para Çek",
    "366": "Bonus",
    "367": "Bayi Para Yatır",
    "368": "Bayi Para Çek",
    "369": "Bakiye Düzelt",
    "370": "Kredi Yükle",
    "371": "Kredi Tahsilat",
    "372": "Manuel Para Yatır",
    "373": "Manuel Para Çek",
    "374": "Casino Bahis",
    "375": "Casino Kazanç",
    "376": "Casino İptal",
    "377": "Kupon Bahis",
    "378": "Kupon Kazanç",
    "379": "Kupon İptal",
    "380": "İzin Verildi",
    "382": "Gol Yemez",
    "383": "Hicbiri",
    "385": "DA",
    "386": "Devre",
    "387": "Periyod",
    "388": "UEFA Şampiyonlar Ligi",
    "389": "UEFA Avrupa Ligi",
    "390": "Sanal",
    "391": "Sistem",
    "392": "Sistem tipini secmeniz gerekiyor!",
    "393": "Canli Anlatım",
    "394": "Istatistikler",
    "395": "TV Oyunları",
    "396": "Zeppelin",
    "397": "s",
    "398": "Birazdan Oynanacaklar",
    "399": "Kayıtlı bir kullanıcımız mısınız? Buraya tıklayarak giriş yapın",
    "400": "Yarışlar",
    "401": "BiGBang",
    "402": "Daha Fazla Göster",
    "403": "Casino Sağlayıcıları",
    "404": "Ödeme Yöntemleri",
    "405": "Canlı Casino Oyunları",
    "406": "Slot Oyunları",
    "407": "Toplam ##x## sonuç bulundu.",
    "408": "Kupon Bozdurma",
    "409": "Cashout tutari degisti veya kapandi! Tekrar deneyiniz.",
    "410": "Cashout gerceklestirildi!",
    "411": "Kupon bozdurma işlemini onayliyor musunuz?",
    "412": "Bahis",
    "413": "Canlı",
    "414": "Canlı Casino",
    "415": "Slot",
    "416": "Sanal",
    "417": "Tombala",
    "418": "TVOyunları",
    "419": "Yarışlar",
    "420": "Promosyon",
    "421": "Lutfen sayfayi sag ustteki X isaretinden kapatiniz!",
    "1165": "Anasayfa",
    "1166": "Müşteriler",
    "1167": "Finans",
    "1168": "Para Yatırma",
    "1169": "Para Çekme",
    "1170": "Muhasebe",
    "1171": "Bahis",
    "1172": "Kuponlar",
    "1173": "Sonuçlandırma",
    "1174": "Canlı",
    "1175": "Maç Öncesi",
    "1176": "Limitlendirme",
    "1177": "Risk",
    "1178": "Tek Maça Kalanlar",
    "1179": "Açık Bahisler",
    "1180": "Karşılaşmalar",
    "1181": "Raporlar",
    "1182": "Casino",
    "1183": "Finans",
    "1184": "Günlük",
    "1185": "Ülke/Lig",
    "1186": "Oran Tipleri",
    "1187": "Oyunlar",
    "1188": "Slot",
    "1189": "Ödeme Methodları",
    "1190": "Bayiler",
    "1191": "Bonus",
    "1192": "Kredi",
    "1193": "İçerik",
    "1194": "Duyurular",
    "1195": "Sayfalar",
    "1196": "Promosyonlar",
    "1197": "Manşet/Slider",
    "1198": "Şablonlar",
    "1199": "IP Yasaklama",
    "1200": "İşlem Geçmişi",
    "1201": "Personel",
    "1202": "Ayarlar",
    "1203": "Kullanıcı veya Kupon",
    "1204": "Kullanıcı adı",
    "1205": "Şifre",
    "1206": "Giriş",
    "1207": "Çıkış yap",
    "1208": "Kurtarma Kodu",
    "1209": "Onayla",
    "1210": "Yenile",
    "1211": "Kar",
    "1212": "Bakiye",
    "1213": "Bugun Giriş",
    "1214": "Toplam Müşteri",
    "1215": "Toplam",
    "1216": "Toplam Yatırım",
    "1217": "Toplam Kazanç",
    "1218": "Açık Kupon",
    "1219": "İptal Kupon",
    "1220": "Toplam Kupon",
    "1221": "Ortalama",
    "1222": "El Sayısı",
    "1223": "Ad",
    "1224": "Yeni Müşteriler",
    "1225": "Kayıt Tarihi",
    "1226": "Aktif Müşteriler",
    "1227": "Müşteri Notları",
    "1228": "Hepsi",
    "1229": "Not",
    "1230": "Tarih",
    "1231": "Kupon Detay",
    "1232": "Oran",
    "1233": "Kazanç",
    "1234": "Tutar",
    "1235": "Bekliyor",
    "1236": "Kaybetti",
    "1237": "Kazandı",
    "1238": "İptal Edildi",
    "1239": "Karşılaşma",
    "1240": "Bahis",
    "1241": "Seçim",
    "1242": "Skor",
    "1243": "Mevcut",
    "1244": "Sonuçlanma Tarihi",
    "1245": "Müşteri Ekle",
    "1246": "No",
    "1247": "Soyad",
    "1248": "Eposta",
    "1249": "Telefon",
    "1250": "Durum",
    "1251": "Aktif",
    "1252": "Pasif",
    "1253": "Kimlik No",
    "1254": "Son Giriş Tarihi",
    "1255": "Ekle",
    "1256": "Onaylandı",
    "1257": "Rededildi",
    "1258": "Bekliyor",
    "1259": "Müşteri Bildirim Mesajı",
    "1260": "Onay",
    "1261": "Red",
    "1262": "Detayı",
    "1263": "Tip",
    "1264": "Manuel Para Yükleme",
    "1265": "Manuel Para Çekme",
    "1266": "Kredi Yükleme",
    "1267": "Kredi Ödeme",
    "1268": "Kupon Oluşturma",
    "1269": "Kupon Kazanç",
    "1270": "Casino Bahis",
    "1271": "Casino Kazanç",
    "1272": "Bayi Para Yükleme",
    "1273": "Bayi Para Çekme",
    "1274": "Önceki",
    "1275": "Sonraki",
    "1276": "Tekli",
    "1277": "Kombine",
    "1278": "Bahis Tip",
    "1279": "Tarih Tip",
    "1280": "Oluşturma",
    "1281": "Sonuçlama",
    "1282": "Oyun",
    "1283": "Toplam Bekleyen",
    "1284": "Kazanan Kupon",
    "1285": "Kaybeden Kupon",
    "1286": "İptal/İade Edilen",
    "1287": "Olası Ödeme",
    "1288": "Toplam Kazanan",
    "1289": "Toplam Kaybeden",
    "1290": "Toplam İade",
    "1291": "Net Kalan",
    "1292": "Site Adı",
    "1293": "Site Adresi",
    "1294": "Site Başlık",
    "1295": "Site Açıklama",
    "1296": "Anahtar Kelimeler",
    "1297": "Eposta Adresi",
    "1298": "Facebook",
    "1299": "Twitter",
    "1300": "Instagram",
    "1301": "Varsayılan Dil",
    "1302": "Google Authenticator",
    "1303": "Kimlik No Düzenle",
    "1304": "Canlı Destek Adresi",
    "1305": "Minimum Kupon Tutarı",
    "1306": "Maximum Kupon Tutarı",
    "1307": "Çekim Yöntemi Seç",
    "1308": "Maksimum Bahis (Karşılaşma)",
    "1309": "Maksimum Bahis (Lig)",
    "1310": "Maksimum Bahis (Oran Tipi)",
    "1311": "Günlük Limit",
    "1312": "Minimum Tekli Oran",
    "1313": "Minimum Kombine Oran",
    "1314": "Minimum Kombine içi Tekli Oran",
    "1315": "Maksimum Kombine Sayısı",
    "1316": "Anasayfa Yönlendirme",
    "1317": "Canlı Futbol Dakika Kapatma",
    "1318": "Canlı Kupon Bekletme Süresi",
    "1319": "Maç Öncesi Oran (%)",
    "1320": "Canlı Maç Oran (%)",
    "1321": "Kaydet",
    "1322": "Varsayılan Bahis Limitleri",
    "1323": "Personel Ekle",
    "1324": "Yeni Şifre",
    "1325": "Yetkiler",
    "1326": "Bakiye Düzenle",
    "1327": "Bonus Ekleme",
    "1328": "Excel",
    "1329": "Personel Düzenle",
    "1330": "Düzenle",
    "1331": "Emin misin?",
    "1332": "Sil",
    "1333": "İşlem",
    "1334": "IP Adresi",
    "1335": "Hedef No",
    "1336": "Kupon Oluşturma",
    "1337": "Para Yükleme",
    "1338": "Para Çekme",
    "1339": "Şifre Değiştir",
    "1340": "Kayıt",
    "1341": "Giriş",
    "1342": "Bayi Silme",
    "1343": "Bayi Düzenleme",
    "1344": "Bayi Ekleme",
    "1345": "Bonus Ekleme",
    "1346": "Manuel Para Yükleme",
    "1347": "Müşteri Silme",
    "1348": "Müşteri Düzenleme",
    "1349": "Müşteri Ekleme",
    "1350": "Kupon Sonuçlandırma",
    "1351": "Para Yatırma İptal",
    "1352": "Para Yatırma Onaylama",
    "1353": "Giriş",
    "1354": "Çıkış",
    "1355": "Manuel Para Çekme",
    "1356": "Ayarlar Güncelleme",
    "1357": "Para Çekme İptal",
    "1358": "Para Çekme Onaylama",
    "1359": "Hesap Detayı Ekle",
    "1360": "Açıklama",
    "1361": "IP Adresi Düzenle",
    "1362": "Sonuç bulunamadı!",
    "1363": "Ödeme Methodu Ekle",
    "1364": "Method",
    "1365": "Evet",
    "1366": "Hayır",
    "1367": "Görsel Adresi",
    "1368": "İşlem Ücreti",
    "1369": "İşlem Süresi",
    "1370": "Minimum Yatırım",
    "1371": "Maksimum Yatırım",
    "1372": "Minimum Çekim",
    "1373": "Maksimum Çekim",
    "1374": "Sıra",
    "1375": "Ödeme Methodu Düzenle",
    "1376": "Talep Et",
    "1377": "Poker",
    "1378": "Tombala",
    "1379": "Minimum Oran",
    "1380": "Yeni üyelere otomatik yüklensin mi?",
    "1381": "Bonus Düzenle",
    "1382": "Eğer otomatik yüklenecek ise",
    "1383": "Yatırım",
    "1384": "Ülke",
    "1385": "Çekim",
    "1386": "Sayı",
    "1387": "Duyuru Ekle",
    "1388": "Dil",
    "1389": "Duyuru",
    "1390": "Duyuru Düzenle",
    "1391": "Sayfa Ekle",
    "1392": "Sayfa",
    "1393": "Sayfa Düzenle",
    "1394": "Promosyon Ekle",
    "1395": "Promosyon",
    "1396": "Promosyon Düzenle",
    "1397": "Slider Ekle",
    "1398": "Slider",
    "1399": "Slider Düzenle",
    "1400": "Bağlantı Adresi",
    "1401": "Yerleşim",
    "1402": "Anasayfa",
    "1403": "Spor Sayfası",
    "1404": "Casino Sayfası",
    "1405": "Slot Sayfası",
    "1406": "Tombala Sayfası",
    "1407": "Poker Sayfası",
    "1408": "Promosyon Sayfası",
    "1409": "CSS",
    "1410": "JS",
    "1411": "Şablon Düzenle",
    "1412": "HTML Kodu",
    "1413": "Müşteri Notu",
    "1414": "Bayi Ekle",
    "1415": "Toplam Bakiye",
    "1416": "Bayi Düzenle",
    "1417": "Hesap",
    "1418": "Rake",
    "1419": "Tombala Detayı",
    "1420": "Bahis Yapılan Numaralar",
    "1421": "Kazanan Numaralar",
    "1422": "Kart Numarası",
    "1423": "Para Yükle/Çek",
    "1424": "Müşteri Düzenle",
    "1425": "Grup",
    "1426": "Cinsiyet",
    "1427": "Belirtilmemiş",
    "1428": "Erkek",
    "1429": "Kadın",
    "1430": "Doğum Tarihi",
    "1431": "Şehir",
    "1432": "Adres",
    "1433": "Not Ekle",
    "1434": "Güncelle",
    "1435": "Yükleniyor",
    "1436": "Çekme",
    "1437": "Müşteri Bildirimleri",
    "1438": "Bildirim Gönder",
    "1439": "Bildirim",
    "1440": "Sağlayıcı",
    "1441": "Spor",
    "1442": "Lig",
    "1443": "Limit Ekle",
    "1444": "Temizle",
    "1445": "Limit Düzenle",
    "1446": "Müşteri Grubu Ekle",
    "1447": "Müşteri Grubu Düzenle",
    "1448": "Müşteri Grupları",
    "1449": "Çoklu IP bulunuyor: ",
    "1450": "Canlı Casino",
    "1451": "Aktif / Pasif",
    "1452": "Destek",
    "1453": "Talep Oluştur",
    "1454": "Popüler Lig",
    "1455": "Konu",
    "1456": "Mesaj",
    "1457": "Gönder",
    "1458": "Cevap Bekliyor",
    "1459": "Cevaplandı",
    "1460": "Kapatıldı",
    "1461": "Sesli Finans Bildirimi",
    "1462": "Son Finansal İşlemler",
    "1463": "Müşteri",
    "1464": "İzin Verildi",
    "1465": "Çoklu IP",
    "1466": "Risk Birimleri",
    "1467": "Renk Kodu #",
    "1468": "Genel",
    "1469": "Futbol",
    "1470": "Basketbol",
    "1471": "Tenis",
    "1472": "Voleybol",
    "1473": "Genel Duyurular",
    "1474": "Takım Adı veya Karşılaşma ID",
    "1475": "Yeni",
    "1476": "Sistem Aç/Kapat",
    "1477": "Yeni Müşteri Kayıt",
    "1478": "Sosyal Medya",
    "1479": "Bayi Bakiye Sıfırlama",
    "1480": "Bayi üyelerinin bakiyeleri sıfırlanmıştır!",
    "1481": "Bayi üyelerinin bakiyeleri silenecektir emin misin?",
    "1482": "Görsel Yükle",
    "1483": "QR Kodunu Google Authenticator uygulamasından okuttun mu?",
    "1484": "Üye Kayıt Adresi",
    "1485": "<p>Google Authenticator nedir?</p> <p>Panel girişlerinde kullanıcı adı ve şifre ile beraber telefonunuza gelen kodu da girmenizi sağlayan güvenlik uygulamasıdır</p><br /><p>Nasıl yapılır?</p> <p>Android veya Iphone telefonlarınızdan Google Authanticator uygulamasını indirip panelde gözüken QR kodunu okutmanız ve onaylamanız yeterlidir. Daha sonra ki tüm girişlerinizde telefonunuza gelen kod ile giriş yapabileceksiniz.</p>",
    "1486": "Youtube",
    "1487": "Müşteri Limiti",
    "1488": "Kupon Yazdir",
    "1489": "Kupon Yap",
    "1490": "Kupon Ödeme",
    "1491": "Oran degisikliklerini kabul ediyorum!",
    "1492": "Oranlar değişti güncel oranlar kabul etmeniz gerekiyor!",
    "1493": "Kuponunuz başarılı bir şekilde kaydedildi!",
    "1494": "Vergi",
    "1495": "Net",
    "1496": "Aşağıda belirtilen tutardaki ödemeyi teslim aldım.",
    "1497": "İmza",
    "1498": "Kupon ödemesi için emin misiniz?",
    "1499": "Kasa Raporu",
    "1500": "Kupon Ödendi",
    "1501": "Kupon iptal için emin misiniz?",
    "1502": "Bahis kuponunuz boş. Lutfen seçim yapınız!",
    "1503": "Sistem",
    "1504": "Kupon Tutari",
    "1505": "Kupon Adedi",
    "1506": "Sistem tipini secmeniz gerekiyor!",
    "1507": "Kupon tutarini belirtiniz!",
    "1508": "Devre",
    "1509": "Periyod",
    "1510": "Kupon Bozdurma",
    "1511": "Logo Adresi",
    "1512": "Ikon Adresi",
    "1513": "Anasayfa Arkaplan",
    "1514": "Spor Arkaplan",
    "1515": "Canli Arkaplan",
    "1516": "Casino Arkaplan",
    "1517": "Slot Arkaplan",
    "1518": "Sanal Arkaplan",
    "1519": "Promosyon Arkaplan",
    "1520": "Kupon Bozdurma Komisyon",
    "1521": "Anasayfa HTML Kod",
    "1522": "Mobil",
    "1523": "Web",
    "1524": "Oranlar",
    "1525": "Kupon Alt HTML Kod",
    "1526": "Aktif Personel",
    "1527": "Cashout Tarih",
    "1528": "Oyun Detayi",
    "1529": "Toplu Limit",
    "1530": "Zorunlu Alan",
    "1531": "Detaylı bilgi",
    "1532": "Bonus talebiniz iletilmiştir! En kısa sürede işlem sonuçlanacaktır.",
    "1533": "Bekleyen talebiniz var iken tekrar talepte bulunamazsınız!",
    "1534": "Bonus Geçmişi (Son 5)",
    "1535": "GoldMine",
    "1536": "Çark",
    "1537": "Diger",
    "1539": "Buz Hokeyi",
    "1540": "Floorball",
    "1541": "Hentbol",
    "1542": "Bandy",
    "1545": "Amerikan Futbolu",
    "1547": "Beyzbol",
    "1548": "Boxing",
    "1549": "Dart",
    "1550": "Snooker",
    "1551": "Masa Tenisi",
    "1552": "Ragbi",
    "1553": "Rugby League",
    "1554": "Curling",
    "1555": "Sutopu",
    "1556": "Avustralya Futbolu",
    "1557": "Cricket",
    "1558": "Çim Hokeyi",
    "1559": "Plaj Voleybolu",
    "1560": "Salon Futbolu",
    "1561": "Golf",
    "1562": "E-Games",
    "1563": "Speedway",
    "1564": "Chess",
    "1565": "Badminton",
    "1566": "Netball",
    "1567": "Squash",
    "1568": "Sumo",
    "1569": "Politics",
    "1570": "Weather",
    "1571": "Lottery",
    "1574": "Sanal",
    "1575": "Canlı Bahis",
    "1576": "Sports & Casino",
    "1577": "Başlangıç Tarihi",
    "1578": "Bitiş Tarihi",
    "1579": "Min Tutar",
    "1580": "Maksimum Tutar",
    "1581": "Son Giriş Tarihi Başlangıç",
    "1582": "Son Giriş Tarihi Bitiş",
    "1583": "Kayıt Tarihi Bitiş",
    "1584": "Kayıt Tarihi Başlangıç",
    "1585": "Yetersiz Bakiye!",
    "1586": "Finans Raporları",
    "1587": "Oyun Raporları",
    "1588": "İşlem gerçekleştirildi!",
    "1589": "Sabit Ücret",
    "1590": "Döviz",
    "1591": "Siteler",
    "1592": "Jackpot",
    "1593": "Sayfa Genişliği",
    "1594": "Kısa Kayıt Formu",
    "1595": "Otomatik Yönlendirme",
    "1596": "Bonus Kutusu",
    "1597": "Popüler Canlı Casino",
    "1598": "Popüler Slot",
    "1599": "Popüler Maçlar",
    "1600": "Sosyal Medya & SEO",
    "1601": "Tasarım & Arayüz",
    "1602": "Alan Adları",
    "1603": "Manuel Bakiye Ekleme",
    "1604": "Manuel Bakiye Çıkarma",
    "1605": "Limit",
    "1606": "Bayi",
    "1607": "Kopyalandı",
    "1608": "Alt Kısım",
    "1609": "Müşteri Notu Silme",
    "1610": "Aktif bonus yok!",
    "1612": "Tutar Düzenleme",
    "1613": "Çekim talebiniz işlem sırasındadır. İşlem durumu güncellendiğinde hesabınızda görüntülenecektir.",
    "1614": "Yatırım talebiniz işleme alınmıştır. En kısa sürede sonuçladırılacaktır.",
    "1615": "Yüzde",
    "1616": "Hugh Logo",
    "1618": "Güvenlik Sertifikası",
    "1619": "Üst Menü",
    "1620": "Minimum Komisyon",
    "1621": "Maliyet",
    "1622": "Aviator",
    "1623": "TVbet",
    "1624": "Ana Sağlayıcı",
    "1625": "Doğum Günü",
    "1626": "Yeni Pencere",
    "1627": "Boyut",
    "1628": "Ortadoğu'nun en büyük online casinosu!",
    "1629": "Popüler",
    "1630": "Geçmiş",
    "1631": "Kupon Düzeltme",
    "1632": "Son 1 ay",
    "1633": "Listele",
    "1634": "Mesaj Gönder",
    "1635": "Otomatik Çekim",
    "1636": "Kazı Kazan",
    "1637": "Canlı TV",
    "1638": "Tamamlandı",
    "1639": "İzin Verildi",
    "1640": "Çekimler arası minimum süre (dakika)",
    "1641": "Çekim tutarları 10 ve katları (evet/hayır)",
    "1642": "Çekim için ana para çevrim şartı kaç kat (rakam)",
    "1643": "Günlük maksimum bonus limiti aşıldı",
    "1644": "Minimum bonus tutarı hatalı",
    "1645": "Maksimum bonus tutarı hatalı",
    "1646": "Çekimlerinizin arası minimum ## dakika olmak zorundadır!",
    "1647": "Çekiminiz 10 ve katları şeklinde olması gerekmektedir!",
    "1648": "Ana para çevrimini tamamladıktan sonra çekim yapabilirsiniz.",
    "1649": "Bakiyeniz yetersiz!",
    "1650": "Cache",
    "1651": "",
    "1652": "Kupon detaylarını görmek için kupon yaptığınız bölümdeki \"Bahis Geçmişi\" sayfasına gitmeniz gerekmektedir.",
    "1653": "",
    "1654": "Grafikler",
    "1655": "",
    "1656": "Freespin",
    "1657": "Bonus Talepleri",
    "1658": "Son finansal işleminiz bonus olduğu için tekrar bonus talebinde bulunamazsınız.",
    "1659": "Bekleyen kuponunuz var iken bonus talebinde bulunamazsınız!",
    "1660": "Sesli Bildirim Tekrarı",
    "1661": "Son çekim bilgilerimi kullan!",
    "1662": "Son 48 saat içerisinde herhangi bir muhasebe kaydınız olmadığı için bonus talebinde bulunamazsınız.",
    "1663": "Hoşgeldin",
    "1664": "Deneme",
    "1665": "Kayıp",
    "1666": "Yatırım/Çekim farkınızdan dolayı herhangi bir bonus almaya hakkınız bulunmamaktadır.",
    "1667": "Kayıp bonusu alabilmeniz için bakiyeniz olmaması gerekmektedir.",
    "1668": "Yatırım bonusu alabilmeniz için bakiyeniz olması gerekmektedir.",
    "1669": "Promosyon Kodu",
    "1670": "(zorunlu değil)",
    "1671": "Otomatik Bonus",
    "1672": "Son 24 saat yatırım/çekim kar zarar kontrolü",
    "1673": "Son işlem bonus kontrolü",
    "1674": "Son 48 saat muhasebe kaydı kontrolü",
    "1675": "Tutar Tip",
    "1676": "Açık kupon kontrolü",
    "1677": "Bonus hakkınız bulunmamaktadır",
    "1678": "Yatırım bonusunuzu yatırım yaptıktan hemen sonra almanız gerekmektedir!",
    "1679": "Sağlayıcı arama...",
    "1680": "Oyun arama...",
    "1681": "Değişen Yüzde",
    "1682": "Kayıp bonusu alabilmek için bakiyenizi tamamen bitirmiş olmanız gerekmektedir",
    "1683": "Aylık",
    "1684": "Son 48 saat de çekimi olanları otomatik bonus kapalı",
    "1685": "Kupon Oluştur",
    "1686": "Etkinlik sona erdi veya bahisler duraklatıldı!",
    "1687": "Gönderilmiş Mesajlar",
    "1688": "Kategori",
    "1689": "Toplu Mesaj",
    "1690": "Turnuvalar",
    "1691": "Çarpan",
    "1692": "Ciro",
    "1693": "Turnuva",
    "1694": "Turnuvanın bitmesine kalan süre:",
    "1695": "gün",
    "1696": "saat",
    "1697": "dk",
    "1698": "sn",
    "1699": "Toplam Ödül",
    "1700": "Turnuva sona erdi",
    "1701": "Tabloyu Yenile",
    "1702": "Turnuvadaki Oyunlar",
    "1703": "Turnuva Notları",
    "1704": "Kural ve Şartlar",
    "1705": "Turnuva Arkaplan",
    "1706": "sonra başlıyor...",
    "1707": "Üst Mesaj",
    "1708": "Çark",
    "1709": "Bonus Talep",
    "1710": "Yatırım Yap",
    "1711": "Bize ulaşın",
    "1712": "Çok yakında...",
    "1713": "Arkadaşına Gönder",
    "1714": "Kullanıcı bulunamadı!",
    "1715": "Bakiyeniz yetersiz!",
    "1716": "Ana para çevrimi yaptıktan sonra transfer yapabilirsiniz!",
    "1717": "Talebiniz arkadaşına gönderilmiştir!",
    "1718": "Alt Menü",
    "1719": "Talebiniz gerçekleştirilmiştir!",
    "1720": "Arkadaşına gönder özelliği ile bakiyenizi site içerisinde istediğiniz bir kullanıcıya transfer edebilirsiniz.",
    "1721": "Kar Efekti",
    "1722": "Personel Notları",
    "1723": "Yıllık",
    "1724": "Güvenlik",
    "1725": "SolidTV",
    "1726": "Çeviriler",
    "1728": "Son yatırım methodunuz ile bonusun yatırım şartı uymadığından bu bonusu alamazsınız.",
    "1729": "İşlem geçmişi",
    "1730": "Kullancı adını değiştir",
    "1731": "Zaman Dilimi",
    "1732": "Olumlu",
    "1733": "Olumsuz",
    "1734": "Ulaşılamadı",
    "1735": "Performans",
    "1736": "Günlük Maksimum Çekim",
    "1737": "##sitename## TV",
    "1738": "Hızlı Cevaplar",
    "1739": "Kısaltma",
    "1740": "Bahisin yeni adresi!",
    "1741": "Yönetici",
    "1742": "Raporlama",
    "1743": "Spor Bahisleri",
    "1744": "Canlı Bahisler",
    "1745": "Slotlar",
    "1746": "Sanal Sporlar",
    "1747": "Yarışlar",
    "1748": "Para Çekme Ekle",
    "1749": "Aldığınız bonus ile maksimum kazanç limiti üzeri çekim yapamazsınız.",
    "1750": "Maksimum Kazanç (kat)",
    "1751": "Komisyon",
    "1752": "Toplam Çekim",
    "1753": "Ortalama Bonus",
    "1754": "Ortalama Üye Kar",
    "1755": "Ortalama Üye Yatırım",
    "1756": "Ortalama Kupon Adedi",
    "1757": "Ortalama Casino El Sayısı",
    "1758": "Ortalama Slot El Sayısı",
    "1759": "Düşük Risk",
    "1760": "Orta Risk",
    "1761": "Yüksek Risk",
    "1762": "Maksimum Casino Çarpan",
    "1763": "Maksimum Slot Çarpan",
    "1764": "2 aydır girmeyenlerin bakiyesini sıfırla",
    "1765": "Maksimum Kazanç (Yatırım kat)",
    "1766": "Mail Şablonları",
    "1767": "Doğum Günü Bonusu",
    "1768": "Çekim için bonus para çevrim şartı kaç kat (rakam)",
    "1769": "Bonus çevrimini tamamladıktan sonra çekim işlemini yapabilirsiniz!",
    "1770": "Geri Dönüş Bonusu",
    "1771": "Türkiye'nin Tek Resmi Casino Sitesi",
    "1772": "Bizi nereden duydunuz?",
    "1773": "Arama motorları",
    "1774": "Sosyal medya",
    "1775": "Arkadaş tavsiyesi",
    "1776": "Diğer",
    "1777": "Ulti TV",
    "1778": "Ulti Piyango",
    "1779": "Ulti Çark",
    "1780": "Nereden Geldi",
    "1781": "Günlük maksimum çekim limitine ulaştınız! Yeni günde tekrar çekim talebi verebilirsiniz.",
    "1782": "Maksimum kazanç limitine ulaştınız! Daha fazla çekim yapamazsınız!",
    "1783": "Maksimum yatırım kazanç limitine ulaştınız! Daha fazla çekim yapamazsınız!",
    "1784": "Eposta Gönder",
    "1785": "Spaceman",
    "1786": "Hızlı Oyunlar",
    "1787": "Alt Toplam",
    "1788": "Pazartesi",
    "1789": "Salı",
    "1790": "Çarşamba",
    "1791": "Perşembe",
    "1792": "Cuma",
    "1793": "Cumartesi",
    "1794": "Pazar",
    "1795": "Özel Değer",
    "1796": "Güvenlik Sözcüğü",
    "1797": "Doğru sitede olduğunuzu anlayabilmeniz için daha sonra size gösterilmek üzere güvenlik sözcüğünüzü belirleyiniz.",
    "1798": "Güvenlik sözcüğünüz başarıyla kaydedildi.",
    "1799": "Ad Soyad Değiştir",
    "1800": "Grafik",
    "1801": "",
    "1802": "##sitename## TV",
    "1804": "Bonusu sadece haftanın ilgili gününde alabilirsiniz.",
    "1805": "Bahis bonusu alamazsınız!",
    "1806": "Casino bonusu alamazsınız!",
    "1807": "Son muhasebe işlem kontrolü",
    "1808": "Kimlik numaranız geçersizdir! Canlı destek üzerinden bilgilerinizi onaylatmanız gerekmektedir.",
    "1810": "Mega",
    "1811": "Major",
    "1812": "Minor",
    "1813": "Mini",
    "1814": "Son Kazanan",
    "1815": "Zaman",
    "1816": "Hesabı Dondur",
    "1817": "Bu web sitesindeki oyun etkinliğinizi kısa bir süre için durdurmak istiyor musunuz? Hesap dondurma özelliği sayesinde, hesabınıza para yükleyemez veya bu web sitesinde bulunan oyunlardan herhangi birini kullanamazsınız.",
    "1818": "24 saat",
    "1819": "1 hafta",
    "1820": "1 ay",
    "1821": "3 ay",
    "1822": "Muhasebe Durum Değiştirme",
    "1823": "Google Authenticator nedir?",
    "1824": "Google Authenticator aktif ediliyor. Aktif ettikten sonra siteden otomatik çıkış yapıp Google Authenticator ile giriş yapmak zorunda kalacaksınız. Emin misiniz?",
    "1825": "İşlem başarılı",
    "1826": "Adet",
    "1827": "Google Authenticator (Personel)",
    "1828": "Google Authenticator (Üyelik)",
    "1829": "Girişte kullanıcı adı ve şifre ile beraber telefonunuzda oluşturduğunuz kodu da girmenizi sağlayan güvenlik uygulamasıdır",
    "1830": "Nasıl yapılır?",
    "1831": "Android veya Iphone telefonlarınızdan Google Authanticator uygulamasını indirip panelde gözüken QR kodunu okutmanız ve onaylamanız yeterlidir. Daha sonra ki tüm girişlerinizde telefonunuzdan oluşturduğunuz kod ile giriş yapabileceksiniz.",
    "1832": "2 aşamalı doğrulama",
    "1833": "Google Authenticator iptal etmek istiyor musunuz?",
    "1834": "Onaylamak için tıklayınız.",
    "1835": "Google Authenticator aktif et",
    "1836": "Hatalı Girişler",
    "1837": "VIP Club",
    "1838": "Ortaklık",
    "1839": "Yardım merkezi",
    "1840": "Gece",
    "1841": "Gündüz",
    "1842": "Menü",
    "1843": "Lobi",
    "1844": "Konferans Ligi UEFA",
    "1845": "NBA",
    "1846": "Kripto Satın Al",
    "1847": "Bağlan",
    "1848": "Sıkça Sorulan Sorular",
    "1849": "Hesap",
    "1850": "Doğrulama",
    "1851": "Demo Oyna",
    "1852": "Gerçek Oyun",
    "1853": "",
    "1854": "Yardıma mı ihtiyacınız var?",
    "1855": "",
    "1856": "",
    "1857": "Baccarat",
    "1858": "Blackjack",
    "1859": "Masa oyunları",
    "1860": "Rulet",
    "1861": "Benzer Oyunlar",
    "1862": "",
    "1863": "Kullanıcı",
    "1864": "Turnuvanın başlamasına kalan süre:",
    "1865": "Kayıtlı bir kullanıcımız mısınız? Buraya tıklayarak ##logintext##",
    "1866": "Giriş yapın",
    "1867": "",
    "1868": "",
    "1869": "REFERANS BAĞLANTISI",
    "1870": "",
    "1871": "",
    "1872": "",
    "1873": "Para kaynağı",
    "1874": "Kullanıcılar",
    "1875": "Kampanyalar",
    "1876": "Sırala",
    "1877": "Kampanya İsabetleri",
    "1878": "Benzersiz Mevduat",
    "1879": "Yeni Kampanya Oluştur",
    "1880": "Son Yatırımlar",
    "1881": "Bahis yapıldı",
    "1882": "Kullanılabilir Komisyon",
    "1883": "Toplam Komisyon",
    "1884": "",
    "1886": "",
    "1887": "",
    "1888": "",
    "1889": "VIP İlerlemeniz",
    "1890": "İlerleme",
    "1891": "Seviye Sistemi",
    "1892": "Bronz",
    "1893": "Gümüş",
    "1894": "Altın",
    "1895": "Platin",
    "1896": "Elmas",
    "1897": "",
    "1898": "",
    "1899": "",
    "1900": "",
    "1901": "",
    "1902": "Bağlantı adresinizi almak için giriş yapmalısınız",
    "1903": "Üzgünüz, bulunduğunuz ülke yasal kısıtlamalar nedeniyle bu online casino sitesine erişiminizi engellemektedir. Bu kısıtlama nedeniyle mevcut konumunuzdan bu casino oyunlarını oynayamazsınız. ",
    "1904": "Herhangi bir sorunuz varsa e-posta göndermekten çekinmeyin!",
    "1905": "",
    "1906": "",
    "1907": "6 ay",
    "1908": "1 yıl",
    "1909": "5 yıl",
    "1910": "Süresiz",
    "1911": "Son 48 saat yatırım/çekim kar zarar kontrolü",
    "1912": "24 saat de 1 kere talep hakkı",
    "1913": "Oyunlar Arka Plan",
    "1914": "Turnuva",
    "1915": "Dünyanın en büyük çevrimiçi kripto kumarhanesi!",
    "1916": "Maksimum Üye Sayısı",
    "1917": "Turnuva kazanan üye tablosu her saat güncellenmektedir.",
    "1918": "Kullanıcı adımı kazananlar bölümlerinde gizle",
    "1919": "Hemen Bonusu Al",
    "1920": "Çark Görseli (720x720)",
    "1921": "İmleç Görsel (328x184) - Kenar Boşlukları (Üst/Alt 10px - Sağ 30px)",
    "1922": "Buton Görsel (242x124)",
    "1923": "Alan Metin",
    "1924": "Alan Değer",
    "1925": "Otomatik Bakiye",
    "1926": "Günde 1 Kere",
    "1927": "Her yatırımda 1 Kere",
    "1928": "Spin Çevir Bonus",
    "1929": "Sınır",
    "1930": "SEO",
    "1931": "Description",
    "1932": "Url",
    "1933": "Title",
    "1934": "Diğer dillerde görüntüle",
    "1935": "Sayfa Bulunamadı",
    "1936": "Grup No",
    "1937": "Eposta Onay Kodu",
    "1938": "Kod Gönder",
    "1939": "Gönderildi",
    "1940": "Ciro",
    "1941": "Çekim için doğrulama kodu",
    "1942": "Çekim yapabilmek için aşağıdaki doğrulama kodunu kullanınız",
    "1943": "Doğrulama Kodu",
    "1944": "Hatalı doğrulama kodu yazdınız!",
    "1945": "Şifre değiştirme talebi",
    "1946": "Şifre değiştirme talebiniz alınmıştır.",
    "1947": "Aşağıdaki bağlantı adresine tıklayarak şifrenizi değiştirebilirsiniz!",
    "1948": "Bol şans dileriz!",
    "1949": "Ortaklık programına kayıt ol",
    "1950": "Kampanya İsmi",
    "1951": "gg.aa.yyyy",
    "1952": "Müşteriler (Bayi)",
    "1953": "Bayiler",
    "1954": "Daha Fazla Göster",
    "1955": "Daha Az Göster",
    "1956": "Skype",
    "1957": "Telegram",
    "1958": "İletişim",
    "1959": "tr",
    "1960": "Dosya Yükle",
    "1961": "Dosya yükleme alanı text",
    "1962": "Yüklü dosyalar",
    "1963": "Dosya",
    "1964": "No",
    "1965": "Google Tag Manager Id (GTM-000000)",
    "1967": " Eposta Adresi Düzenle",
    "1968": "Telefon Düzenle",
    "1969": "Kopyala",
    "1970": "Aktivasyon için kodu giriniz",
    "1971": "Çekim Önceliği",
    "1972": "Riskli işlem",
    "1973": "Çekim Adresleri",
    "1974": "Levant Özel",
    "1975": "High Flyer",
    "1976": "Karlılık",
    "1977": "Haftalık Bonus",
    "1978": "Kayıp Bonusu",
    "1979": "Komisyon İadesi",
    "1980": "Aylık Bonus",
    "1981": "Ödüller",
    "1982": "Her seviyede yeni ödüller",
    "1983": "Bahis Miktarı",
    "1984": "",
    "1985": "Hesap Doğrulama",
    "1986": "Doğrulama Kodu Gönder",
    "1987": "Kod İste",
    "1988": "Telefon numaranıza doğrulama kodu gönderilecektir. Numaranızı kontrol edip kod iste butonuna basınız.",
    "1989": "Bir Kez",
    "1990": "Tekrarlama",
    "1991": "Özel",
    "1992": "Tüm Oyunlar",
    "1993": "Durum Değiştirme",
    "1994": "Haftalık",
    "1995": "Zayıf",
    "1996": "Yetersiz",
    "1997": "Orta",
    "1998": "Güçlü",
    "1999": "Sizin güvenliğiniz için şifrenizi her 3 ay da bir güncellemeniz gerekmektedir.",
    "2000": "Yeni şifreniz eski şifrenizden farklı olmalıdır",
    "2001": "Bu site reCAPTCHA tarafından korunmaktadır ve Google <a href=\"https://policies.google.com/privacy\" target='_blank'>Gizlilik Politikası</a> ve <a href=\"https://policies.google.com/terms\" target='_blank'>Hizmet Koşulları</a>’na tabidir.",
    "2002": "Şifreniz kullanıcı adınızdan farklı olmalıdır!",
    "2003": "Lütfen gerçek kişi olduğunuzu doğrulayın",
    "2004": "Geçersiz doğrulama kodu",
    "2005": "Anahtarlar",
    "2006": "Hatalı Google Authenticator kodu",
    "2007": "Toplam Bonus Tutarı",
    "2008": "Tüm hesaplardaki kullanılabilir bakiye",
    "2009": "Brüt Kar",
    "2010": "Net Kar",
    "2011": "GGR (Brüt Oyun Geliri)",
    "2012": "NGR (Net Oyun Geliri)",
    "2013": "NRCs (Yeni Kaydolan Müşteriler)",
    "2014": "Yatırım Sayısı",
    "2015": "UDC (Benzersiz Yatırımcı Sayısı)",
    "2016": "NDC (Yeni para yatıran müşteri) Sayısı",
    "2017": "FTD (İlk kez yatırım yapan müşteri) Sayısı",
    "2018": "FTD Tutar Ortalaması",
    "2019": "ARPPU (Ortalama Müşteri Başı Gelir)",
    "2020": "Aktif Müşteriler (Son 3 ay)",
    "2021": "Pasif Müşteriler (Son 3 ay)",
    "2022": "Müşteri Kayıp Oranı",
    "2023": "İlk kez yatırım yapanlar",
    "2024": "Yeni yatırım yapanlar",
    "2025": "Yatırım yapanlar",
    "2026": "İzin Verilen Sağlayıcılar",
    "2027": "Toplu Mail Gönder",
    "2028": "Müşteri Listesi",
    "2029": "Telefon Bakma",
    "2030": "Eposta Bakma",
    "2031": "TC Kimlik Bakma",
    "2032": "Müşteri ödeme güncelleme",
    "2033": "Çekim adreslerini sıfırlama",
    "2034": "Müşteri Ekleme",
    "2035": "Müşteri bonus yetkisi güncelleme",
    "2036": "Müşteri yetki güncelleme",
    "2037": "Müşteir şifre değiştirme",
    "2038": "Müşteri method yetkileri güncelleme",
    "2039": "Muhasebe bakma",
    "2040": "Müşteriye bakma",
    "2041": "Teslimat",
    "2042": "Ödemeler",
    "2043": "Maaş",
    "2044": "Marketing",
    "2045": "Teknik",
    "2046": "Eposta, Kullanıcı adı veya Telefon bilgilerinden birini kullanarak doğrulama kodunuzu telefon ve eposta yoluyla alabilir ve yeni şifrenizi oluşturabilirsiniz.",
    "2047": "Eposta ve telefon yoluyla aldığınız doğrulama kodunu girerek yeni şifrenizi oluşturun.",
    "2048": "Yeni şifreniz ile hemen ##logintext##",
    "2049": "Oyun Kodu",
    "2050": "Masaüstü",
    "2051": "Toplu Bonus Ekle",
    "2052": "Kullanıcı Adı (Her satıra 1 kayıt)",
    "2053": "Aşağıdaki müşterilere bonus eklenemedi!",
    "2054": "Personel İsmi",
    "2055": "",
    "2056": "android cihazınız için yükleyin",
    "2057": "iOS cihazınız için yükleyin",
    "2058": "Güncel adresimize her zaman ##domain## yazarak giriş yapabilirsiniz.",
    "2059": "Bizi Takip Edin!",
    "2060": "Reklam ve Affiliate Anlaşmaları",
    "2061": "Destek ve Yardım",
    "2062": "İstek ve Öneriler",
    "2063": "",
    "2064": "",
    "2065": "Kredi Kartı",
    "2066": "##sitename## © ##year## - Tüm Hakları Saklıdır.",
    "2067": "Öne Çıkan Oyunlar",
    "2068": "Popüler slot ve casino oyunlarını keşfedin.",
    "2069": "Oyunlar yüklenemedi",
    "2070": "Oyun URL alınamadı",
    "2071": "Oyun başlatılamadı",
    "2072": "Tüm Sağlayıcılar",
    "2073": "Filtreleri temizleyip tekrar deneyin.",
    "2074": "Canlı Casino Heyecanı",
    "2075": "Gerçek krupiyeler ile kazanmaya başla!",
    "2076": "Giriş yapılıyor...",
    "2077": "Promosyonlar yüklenemedi",
    "2078": "Şu anda aktif promosyon bulunmuyor.",
    "2079": "Yeni kampanyalar eklendiğinde burada görünecek.",
    "2080": "Bonuslara Git",
    "2081": "Seçili kampanyalarımızı inceleyin, koşulları görün ve bonus fırsatlarını kaçırmayın.",
    "2082": "Görsel Yok",
    "2083": "##title## promosyonunu görüntüle",
    "2084": "Lütfen giriş yapın",
    "2085": "Kullanıcı ID bulunamadı",
    "2086": "Sportsbook başlatılamadı",
    "2087": "Sportsbook yüklenemedi",
    "2088": "Sportsbook sağlayıcı bilgileri yapılandırılmadı.",
    "2089": "Sportsbook sağlayıcı istemcisi yüklenemedi",
    "2090": "Bootstrapper bulunamadı",
    "2091": "Hata",
    "2092": "Yeniden Dene",
    "2093": "Spor bahis yükleniyor...",
    "2094": "Görsel Yüklenemedi",
    "2095": "Az önce",
    "2096": "Popüler Slotlar",
    "2097": "",
    "2098": "",
    "2099": "",
    "2100": "",
    "2101": "",
    "2102": "",
    "2103": "",
    "2104": "",
    "2105": "",
    "2106": "",
    "2107": "Giriş başarısız",
    "2108": "Hesabınız yok mu?",
    "2109": "Sponsorluk",
    "2110": "Genel Kurallar",
    "2111": "Sorumlu Oyun",
    "2112": "Popüler Casino Oyunları",
    "2113": "Masa",
    "2114": "Oyun bulunamadı.",
    "2115": "Sağlayıcı seçimi",
    "2116": "Filtreleri Temizle",
    "2117": "Spor bahis için giriş yapmalısınız",
    "2118": "Oyna",
    "2119": "VIP seviyeleri şu anda görüntülenemiyor.",
    "2120": "Ayrıcalıklarla dolu dünyamıza hoş geldiniz.",
    "2121": "Mevcut Seviyeniz",
    "2122": "VIP ayrıcalıklarını görmek için giriş yapmalısınız.",
    "2123": "Ayrıcalıkları",
    "2124": "",
    "2125": "",
    "2126": "",
    "2127": "",
    "2128": "",
    "2129": "",
    "2130": "",
    "2131": "",
    "2132": "Bir hata oluştu",
    "2133": "",
    "2134": "",
    "2135": "Büyük Jackpot",
    "2136": "ID",
    "2137": "Uygulama yüklenemedi",
    "2138": "Dil",
    "2139": "Türkçe",
    "2140": "English",
    "2141": "Hesabı dondurmayı onaylıyorum.",
    "2142": "Net kaybınız bu bonus için belirlenen minimum tutarın altındadır.",
    "2143": "Günlük bonus hakkınızı bugün kullandınız.",
    "2144": "Deneme bonusu sadece daha önce bonus kullanmamış kullanıcılar içindir.",
    "2145": "Deneme bonusu sadece sıfır işlemli kullanıcılar içindir.",
    "2146": "İşlem geçmişiniz bulunamadığı için bu kuralı sağlayamıyorsunuz.",
    "2147": "Son 24 saatteki işlemleriniz karda olduğu için bu bonusu alamazsınız.",
    "2148": "Son 48 saatteki işlemleriniz karda olduğu için bu bonusu alamazsınız.",
    "2149": "Zaten aktif bir bonusunuz var.",
    "2150": "Bonus bulunamadı veya pasif.",
    "2151": "Bu bonus manuel onay gerektiriyor.",
    "2152": "Bonus kimliği sayısal olmalıdır.",
    "2153": "Bonus kutusu açılmamış.",
    "2154": "Son işleminiz ##types## olmalıdır.",
    "2155": "Kullanıcı bulunamadı (ID: ##id##).",
    "2156": "Kullanıcı kimliği doğrulanamadı. (ID: ##id##)",
    "2157": "Geçersiz kullanıcı kimliği.",
    "2158": "Kullanıcı hesabı aktif değil.",
    "2159": "Oturum açmanız gerekiyor.",
    "2160": "Geçersiz site kimliği.",
    "2161": "Aynı IP adresi ile birden fazla hesap tespit edildi.",
    "2162": "Hoşgeldin bonusu sadece ilk yatırımda kullanılabilir.",
    "2163": "Kalan bonus çevrimi",
    "2164": "Kalan ana para çevrimi",
    "2167": "Kısa sürede çok fazla işlem yapıldığı için bonus verilemedi.",
    "2168": "Son 7 günde çok sayıda IP adresi kullanıldığı için bonus verilemedi.",
    "2169": "Bonus kullanım limiti aşıldığı için bonus verilemedi.",
    "2170": "Bonus güvenlik kontrolleri nedeniyle verilemedi.",
    "2171": "En yüksek seviyeye ulaştınız!",
    "2172": "##tier## seviyesine ulaşmak için ##xp## XP daha gerekiyor.",

    "2200": "Oturum bilgisi eksik. Lütfen giriş yapın.",
    "2201": "Oturum süreniz dolmuş. Lütfen tekrar giriş yapın.",
    "2202": "Geçersiz oturum bilgisi.",
    "2203": "Yetkilendirme hatası.",
    "2204": "Kullanıcı adı veya şifre hatalı.",
    "2205": "Bu siteye erişim yetkiniz bulunmuyor.",
    "2206": "Bu işlem için yetkiniz yok.",
    "2207": "Geçersiz giriş bilgisi. Lütfen kontrol edip tekrar deneyin.",
    "2208": "Bu kayıt zaten mevcut.",
    "2209": "Aradığınız kayıt bulunamadı.",
    "2210": "Çok fazla istek gönderdiniz. Lütfen biraz bekleyip tekrar deneyin.",
    "2211": "İmza doğrulaması başarısız.",
    "2212": "İstek zaman aşımına uğradı. Lütfen tekrar deneyin.",
    "2213": "Beklenmeyen bir hata oluştu. Lütfen daha sonra tekrar deneyin.",
    "2214": "Site kimliği gereklidir.",
    "2215": "Canlı bağlantı yetkilendirmesi başarısız. Lütfen tekrar giriş yapın.",
    "2216": "Canlı bağlantı kurulamadı. Arka planda yeniden denenecek.",
    "2217": "Canlı bağlantı tekrar denemeleri tükendi. Lütfen sayfayı yenileyin.",
    "2218": "Sayfa yüklenemedi. Lütfen yenileyip tekrar deneyin.",
    "2220": "Mesajınız alındı. En kısa sürede size dönüş yapılacaktır.",
    "2221": "Hesap donduruldu.",
    "2222": "Partner görselleri bulunamadı.",
    "2223": "Telefon / E-posta / Telegram / Skype",
    "2224": "Henüz bildiriminiz yok.",
    "2225": "",
    "2226": "",
    "2227": "",
    "2228": "",
    "2229": "",
    "2230": "",
    "2231": "",
    "2232": "",
    "2233": "",
    "2234": "",
    "2235": "",
    "2236": "",
    "2237": "",
    "2238": "",
    "2239": "",
    "2240": "",
    "2241": "",
    "2242": "",
    "2243": "VIP Kulübüne Hoş Geldiniz",
    "2244": "",
    "2245": "",
    "2246": "Seviyeler ve Ödüller",
    "2247": "Günlük Maksimum Çekim",
    "2248": "Bonus merkezi üzerinden kullanıcı iptali",
    "2249": "Ana içeriğe geç",
    "2250": "Yeni Oyunlar",
    "2251": "Editörün Seçtikleri",
    "2252": "",
    "2253": "",
    "2254": "Tümünü Gör",
    "2261": "Ayarlar",
    "2262": "Platform",
    "2263": "Hakkımızda",
    "2264": "Para Birimi",
    "2265": "Dil",
    "2266": "İletişim",
    "2267": "Destek",
    "2268": "Partnerlik",
    "2269": "Genel",
    "2270": "İletişim bilgisi tanımlanmamış.",
    "2271": "Sadakat Programı",
    "2272": "SSS",
    "2273": "AML Politikası",
    "2274": "Sorumlu Oyun",
    "2275": "Gizlilik Politikası",
    "2276": "Kullanım Şartları",
    "2277": "Spor Politikası",
    "2278": "Alan adı",
    "2279": "Yardım Merkezi",
    "2280": "",
    "2281": "",
    "2282": "Destek:",
    "2283": "",
    "2284": "Desteklenen ödeme coinleri",
    "2285": "Partner listesi yüklenemedi.",
    "2286": "",
    "2287": "Futbol",
    "2288": "Counter-Strike",
    "2289": "Buz Hokeyi",
    "2290": "Tenis",
    "2291": "Basketbol",
    "2292": "Bisiklet",
    "2293": "Amerikan Futbolu",
    "2294": "Hentbol",
    "2295": "Boks",
    "2296": "Kriket",
    "2297": "Beyzbol",
    "2298": "League of Legends",
    "2299": "Spor Bahis",
    "2300": "Sağlayıcılar",
    "2301": "VIP",
    "2302": "Bu adresi hızlı çekim adresi olarak kaydet",
    "2303": "Kayıtlı adresler",
    "2304": "Şans Çarkı",
    "2305": "Dokun ve çevir",
    "2306": "Veri alınamadı",
    "2307": "Tarih",
    "2308": "ID",
    "2309": "Kazanan",
    "2310": "Tutar",
    "2311": "Henüz kazanan yok",
    "2312": "Toplam Kazanç",
    "2313": "Toplam Kazanan",
    "2400": "Yardım Merkezi",
    "2401": "Sıkça sorulan soruların cevaplarını bulun.",
    "2402": "Henüz kategori yok",
    "2403": "görüntülenme",
    "2404": "faydalı buldu",
    "2405": "Öne çıkan makaleler",
    "2406": "Tüm kategoriler",
    "2407": "Bu kategoride henüz makale yok",
    "2408": "Arama sonuçları",
    "2409": "sonuç bulundu",
    "2410": "Aramanızla eşleşen makale yok",
    "2411": "Makale bulunamadı",
    "2412": "Bu makale yararlı oldu mu?",
    "2413": "Geri bildiriminiz için teşekkürler!",
    "2414": "Geri bildiriminiz alındı, daha iyisi için çalışıyoruz.",
    "2415": "Evet",
    "2416": "Hayır",
    "2417": "Destek ile görüş",
    "2418": "Makalelerde ara...",
    "2419": "Henüz VIP seviyesi tanımlanmamış.",
    "2420": "Henüz anasayfa içeriği tanımlanmamış.",
    "2421": "Bağlantı Kurulamadı",
    "2422": "Oturumunuz doğrulanamadı. Lütfen yeniden deneyin.",
    "2423": "Site ayarları yüklenemedi. Lütfen yeniden deneyin.",
    "2424": "Site bu adres için doğrulanamadı. Lütfen yeniden deneyin.",
    "2425": "Görevler yüklenemedi. Lütfen yeniden deneyin.",
    "2426": "Ödül alınamadı. Lütfen yeniden deneyin.",
    "2427": "Doğrula",
    "2428": "Geri Dön",
    "2429": "Authenticator uygulamanızdaki 6 haneli doğrulama kodunu girin.",
    "2430": "2FA Kodu",
    "2431": "Lütfen güvenlik doğrulamasını tamamlayın.",
    "2432": "Hesap",
    "2433": "Finans",
    "2434": "Hareketler",
    "2435": "VIP seviyeleri ve ödüller",
    "2436": "Anasayfa düzeni yükleniyor",
    "2437": "Öne çıkan yardım içerikleri yüklenemedi.",
    "2438": "Bildirimi kapat",
    "2439": "Dönüş hakkı",
    "2440": "Görevini bitir, dönüşünü al",
    "2441": "Görevler",
    "2442": "Yatırım şartları",
    "2443": "Görevlerden bağımsız ilerler.",
    "2444": "Gerekli yatırım adedi",
    "2445": "Toplam yatırım",
    "2446": "Bu dönem için genel yatırım şartları tamamlandı.",
    "2447": "Kodunu gir, bonusunu aç",
    "2448": "Promosyon kodu",
    "2449": "Dönüyor...",
    "2450": "Wild Market'i aç",
    "2451": "Wild ödüllerini takas et",
    "2452": "Bakiye",
    "2453": "Turnuvalar",
    "2454": "Aktif ve yaklaşan turnuvalara göz atın, ödül havuzunda yerinizi alın.",
    "2455": "Şu anda görüntülenecek turnuva yok.",
    "2456": "Ciro",
    "2457": "Çarpan",
    "2458": "Sağlayıcı",
    "2459": "Aktif",
    "2460": "Yakında",
    "2461": "Tamamlandı",
    "2462": "Ödül Havuzu",
    "2463": "Başlangıç",
    "2464": "Bitiş",
    "2465": "Detay",
    "2466": "Turnuva",
    "2467": "Geri Dön",
    "2468": "Turnuva bulunamadı",
    "2469": "Aradığınız turnuva kaldırılmış veya sona ermiş olabilir.",
    "2470": "Liderlik Tablosu",
    "2471": "Henüz katılımcı yok.",
    "2472": "Turnuva Oyunları",
    "2473": "Yenile",
    "2474": "Sıra",
    "2475": "Kullanıcı",
    "2476": "Skor",
    "2477": "Kazanç",
    "2478": "Özel",
    "2479": "Spor",
    "2480": "Casino",
    "2481": "Slot",
    "2482": "Tüm Oyunlar",
    "2483": "##sitename## Originals",
    "2484": "Bonus Buy",
    "2485": "Kart",
    "2486": "Spor",
    "2487": "Şifreyi göster",
    "2488": "Şifreyi gizle",
    "2489": "Lütfen 6 haneli doğrulama kodunu girin.",
    "2490": "Genel Kurallar ve Şartları kabul etmelisiniz.",
    "2491": "Geçerli bir telefon numarası girin.",
    "2492": "Lütfen kayıt akışına yeniden başlayın.",
    "2493": "Lütfen doğrulama kodunu girin.",
    "2494": "Doğrulama Kodu",
    "2495": "Doğrula ve Kayıt Ol",
    "2496": "Kodu Tekrar Gönder",
    "2497": "Telefon ülke kodunu seç",
    "2498": "Doğum tarihi seç",
    "2499": "Hesap geçici olarak kilitlendi. Lütfen daha sonra tekrar deneyin.",
    "2500": "Doğrulama kodu geçersiz.",
    "2501": "Doğrulama kodu geçersiz veya süresi dolmuş.",
    "2502": "Kurulum oturumu sona erdi. Lütfen yeniden başlatın.",
    "2503": "2FA zaten aktif.",
    "2504": "2FA aktif değil.",
    "2505": "Bu hesap için 2FA zorunlu. Devre dışı bırakmak için panel yöneticisine başvurun.",
    "2506": "Bu kullanıcı adı zaten kullanılıyor.",
    "2507": "Bu e-posta zaten kullanılıyor.",
    "2508": "Bu telefon numarası zaten kayıtlı.",
    "2509": "Geçerli bir telefon numarası gerekli.",
    "2510": "Genel şartlar ve gizlilik bildirimi onayı gerekli.",
    "2511": "Doğrulama oturumu geçersiz.",
    "2512": "Doğrulama oturumu geçersiz veya süresi doldu.",
    "2513": "Bu telefon numarasına çok fazla SMS gönderildi. Lütfen daha sonra tekrar deneyin.",
    "2514": "##phone## numarasına doğrulama kodu gönderdik. Kaydı tamamlamak için aşağıya girin.",
    "2515": "##seconds## sn. içinde tekrar gönder",
    "2516": "##sitename## Ödülleri",
    "2517": "Ödül Merkezi",
    "2518": "Günlük görevlerini tamamla, hakkını kazan ve ödül çarkını güvenle döndür.",
    "2519": "Çözülüyor...",
    "2520": "Kodu kullan",
    "2521": "Çarkı çevir",
    "2522": "Çark çevrilemez",
    "2523": "Çarka tıkla",
    "2524": "Önce hak kazan",
    "2525": "Wild bilgileri yükleniyor",
    "2526": "Wild bilgileri şu anda kullanılamıyor",
    "2527": "Wild Market'i aç — ##reward## hazır",
    "2528": "Wild Market'i aç — ##balance##/##target## Wild (##reward##)",
    "2529": "Çarktan topladığın Wild jetonlarını buradan ödüllerle değiştir.",
    "2530": "Şu an takas edilebilir ödül yok. Wild biriktirmeye devam et.",
    "2531": "Fiziksel ödül",
    "2532": "##stock## stok",
    "2533": "Takas ediliyor...",
    "2534": "Yetersiz Wild",
    "2535": "Stok yok",
    "2536": "Takas Et",
    "2537": "Cüzdan",
    "2538": "Uyarılar",
    "2539": "Hesap merkezi",
    "2540": "Takımın",
    "2541": "Takımını seç",
    "2542": "Takım seçiniz",
    "2543": "Kullanılabilir Bonuslar",
    "2544": "Hızlı erişim",
    "2545": "Kurulum Anahtarı",
    "2546": "Aktif Cihazlar ve Oturumlar",
    "2547": "Hesabınıza giriş yapmış cihazları görün ve tek tek kapatın.",
    "2548": "Oturumlar yükleniyor...",
    "2549": "Aktif oturum bulunamadı.",
    "2550": "Bu cihaz",
    "2551": "Şu an aktif görev yok.",
    "2552": "Ödeme yöntemleri şu anda alınamıyor.",
    "2553": "Para çekme uygunluğu şu anda doğrulanamıyor.",
    "2554": "Para çekme uygunluğu doğrulanıyor...",
    "2555": "QR kodu oluşturulamadı. Anahtarı manuel olarak kullanın.",
    "2556": "Kurulum anahtarı kopyalandı.",
    "2557": "Kurulum anahtarı kopyalanamadı.",
    "2558": "2FA başarıyla etkinleştirildi.",
    "2559": "Mevcut şifrenizi girin.",
    "2560": "2FA devre dışı bırakıldı.",
    "2561": "Oturum kapatıldı.",
    "2562": "Authenticator uygulaması ile ek giriş doğrulaması.",
    "2563": "Artık girişte 6 haneli doğrulama kodu istenir.",
    "2564": "Mevcut Şifre",
    "2565": "Mevcut şifreniz",
    "2566": "İşleniyor...",
    "2567": "2FA'yı Kapat",
    "2568": "Authenticator uygulamanıza aşağıdaki anahtarı ekleyin. Ardından uygulamadaki 6 haneli kodu doğrulayın.",
    "2569": "2FA QR kodu",
    "2570": "Anahtarı Kopyala",
    "2571": "6 Haneli Kod",
    "2572": "Bu kurulum oturumu ##time## saatine kadar geçerli.",
    "2573": "Doğrulanıyor...",
    "2574": "2FA'yı Etkinleştir",
    "2575": "Vazgeç",
    "2576": "Hesabınıza girişte ekstra doğrulama kodu ekleyin. Şifreniz sızsa bile hesabınıza erişimi ciddi biçimde zorlaştırır.",
    "2577": "Hazırlanıyor...",
    "2578": "2FA Kurulumunu Başlat",
    "2579": "Bilinmeyen cihaz",
    "2580": "Tarayıcı bilgisi yok",
    "2581": "Son kullanım",
    "2582": "Kapatılıyor...",
    "2583": "Bu Oturumu Kapat",
    "2584": "Oturumu Kapat",
    "2585": "Freebetlerim",
    "2586": "Hub88 oyunlarında kullanılabilen ödülleriniz.",
    "2587": "Freebetler yenileniyor",
    "2588": "Freebetleriniz yükleniyor...",
    "2589": "Freebet bilgileri şu anda alınamıyor.",
    "2590": "Kullanılabilir bonuslar şu anda alınamıyor.",
    "2591": "Henüz tanımlı bir Hub88 Freebet ödülünüz yok.",
    "2592": "Durum bekleniyor",
    "2593": "Bahis değeri",
    "2594": "Bahis adedi",
    "2595": "Oyuna Git",
    "2596": "Oyun açılıyor...",
    "2597": "Ödül oyunu şu anda açılamıyor. Lütfen tekrar deneyin.",
    "2598": "Önceki",
    "2599": "Bekliyor",
    "2600": "İptal edildi",
    "2601": "Başarısız",
    "2602": "Süresi doldu",
    "2603": "Yatırım adedi",
    "2604": "Yatırım tutarı",
    "2605": "Giriş serisi (gün)",
    "2606": "Pencere içi giriş",
    "2607": "Oyun turu",
    "2608": "Alındı",
    "2609": "Ödülü Al",
    "2610": "Beklemede",
    "2611": "Ödül hesabınıza tanımlandı",
    "2612": "Ödül alındı",
    "2613": "Şu an ##credits## kullanılabilir çark hakkın var.",
    "2614": "Şimdi çarkı çevirebilirsin.",
    "2615": "Ödül: ##amount## spin",
    "2616": "##days## gün geçerli",
    "2617": "Durum",
    "2618": "Tekrar deneniyor...",
    "2619": "Çevrim devam ediyor",
    "2620": "Toplam kalan çevrim: ##amount##.",
    "2621": "Bonus: ##amount##",
    "2622": "Anapara: ##amount##",
    "2623": "Mobil navigasyon",
    "2624": "Ana navigasyon",
    "2625": "Yardımcı navigasyon",
    "2626": "İkincil navigasyon",
    "2627": "Hızlı işlemler",
    "2628": "Etkileşim",
    "2629": "Sosyal medya",
    "2630": "Menüyü aç",
    "2631": "Navigasyonu kapat",
    "2632": "Diğer navigasyonu kapat",
    "2633": "Diğer navigasyon",
    "2634": "Hızlı navigasyon",
    "2635": "Modal arka planını kapat",
    "2636": "Modalı kapat",
    "2637": "Yükleniyor",
    "2638": "Operatör Bilgileri",
    "2639": "##site##, ##legalName## tarafından işletilmektedir. Kayıtlı adres: ##address##. İletişim:",
    "2640": "Wild ödül takas edildi",
    "2641": "Kod başarıyla kullanıldı",
    "2642": "Fiziksel ödül:",
    "2643": "Kazanılan:",
    "2644": "Sonuç:",
    "2645": "Güvenlik doğrulaması yapılandırılmadı.",
    "2646": "Benzer oyunlar şu anda kullanılamıyor.",
    "2647": "Benzer oyun bulunamadı.",
    "2648": "Öneriler şu anda kullanılamıyor.",
    "2649": "BETBY müşteri arayüzü henüz etkinleştirilmedi. Resmî web istemcisi ve izin verilen alan adları yapılandırıldıktan sonra bu ekran açılacaktır.",
    "2650": "Bu seçim yalnızca bir kez yapılabilir.",
    "2651": "Kaydediliyor...",
    "2652": "Takımı Kaydet",
    "2653": "Anjouan lisans bilgileri",
    "2654": "Lisans numarası",
    "2655": "Lisans türü",
    "2656": "Onaylı alan adı",
    "2657": "Şirket kayıt numarası",
    "2658": "Kayıtlı adres",
    "2659": "Kategoriler yüklenemedi.",
    "2660": "Çark kampanyası aktif değil.",
    "2661": "Aktif çark segmenti bulunamadı.",
    "2662": "Kullanılabilir çark hakkınız yok.",
    "2663": "Geçersiz promosyon kodu.",
    "2664": "Bu promosyon kodunu zaten kullandınız.",
    "2665": "Wild ödülü bulunamadı veya pasif durumda.",
    "2666": "Bu Wild ödülünün stoğu tükenmiş.",
    "2667": "Wild bakiyeniz yetersiz.",
    "2668": "Lütfen takım seçin.",
    "2669": "Takım seçiminiz kaydedildi.",
    "2670": "Para çekme uygunluğu şu anda doğrulanamıyor. Lütfen tekrar deneyin.",
    "2671": "Çevrim şartları tamamlanmadan para çekme talebi oluşturamazsınız.",
    "2672": "Bonus talebiniz alındı. Onaylandığında bildirilecektir.",
    "2673": "Şifrenizi sıfırlayın",
    "2674": "Hesabınıza bağlı e-posta adresini girin. Uygun bir hesap varsa sıfırlama bağlantısı göndeririz.",
    "2675": "E-posta adresi",
    "2676": "Sıfırlama bağlantısı gönder",
    "2677": "Bu e-posta adresiyle eşleşen uygun bir hesap varsa şifre sıfırlama bağlantısı gönderildi.",
    "2678": "Yeni şifre",
    "2679": "Yeni şifreyi doğrulayın",
    "2680": "Şifreyi sıfırla",
    "2681": "Şifreniz başarıyla değiştirildi. Artık yeni şifrenizle giriş yapabilirsiniz.",
    "2682": "Bu sıfırlama bağlantısı geçersiz veya süresi dolmuş. Yeni bir bağlantı isteyin.",
    "2683": "İşlem şu anda tamamlanamadı. Lütfen daha sonra tekrar deneyin.",
    "2684": "Giriş ekranına dön",
    "2685": "Şifreniz 8-256 karakter olmalıdır. Büyük/küçük harf, rakam veya sembol zorunluluğu yoktur.",
    "2686": "Detaylar",
    "2687": "Bonusu Al",
    "2688": "Canlı Bahis",
    "2689": "Hesap oluştur",
    "2690": "Üyeliğin için aşağıdaki bilgileri doldur.",
    "2691": "Zaten hesabın var mı?",
    "2692": "Yatırım yöntemi",
    "2693": "Ödeme sayfası",
    "2694": "Banka bilgisi ile transfer",
    "2695": "Yatırım tutarını ödeme sağlayıcısının sayfasında girin. Ödeme onaylanınca bakiyeniz güncellenir.",
    "2696": "Ödeme sayfasını aç",
    "2697": "Transfer için aşağıdaki hesap bilgilerini kullanın. İşlem onaylanınca bakiyeniz güncellenir.",
    "2698": "Banka transferi için tutar tam TL olmalıdır.",
    "2699": "Bu yatırım yöntemi şu anda kullanılamıyor.",
    "2700": "Hesap sahibi",
    "2701": "Referans",
    "2702": "İşlem durumu doğrulanıyor. Ödeme sayfasını aç düğmesiyle aynı işlemi yeniden kontrol edebilirsiniz.",
    "2703": "Bu hesapta sonuçlanmamış bir VIPPay yatırım talebi var. Yeni yatırım için önce mevcut işlemin sonuçlanmasını bekleyin.",
    "2704": "Geçerli bir Türkiye IBAN'ı girin.",
    "2705": "Bu bonus için kullanılabilir onaylı yatırım bulunamadı.",
    "2706": "Bu bonus için kullanım hakkınız dolmuştur.",
    "2707": "Hoşgeldin bonusu için geçerli yatırım sırasının dışındasınız.",
    "2708": "Bu yatırım için hoşgeldin bonusunu zaten kullandınız.",
    "2709": "Bu yatırım daha önce bir bonus için kullanıldı.",
    "2710": "Bonus talep etmek için kimlik onayı gerekmektedir.",
    "2711": "Bu bonus sadece belirli günlerde geçerlidir.",
    "2712": "Bu bonus sadece belirli saatlerde geçerlidir.",
    "2713": "Bonus talebi işleniyor, lütfen bekleyin.",
    "2714": "Bonus kurallarına uygun değilsiniz.",
    "2715": "Bonus talebi şu anda işlenemiyor.",
    "2716": "Zaten bekleyen bonus talebiniz var.",
    "2717": "Bu bonus için yeterli net kaybınız (Yatırım - Çekim) bulunmamaktadır.",
    "2718": "Hoşgeldin bonusunu daha önce kullandınız.",
    "2719": "Yatırım bonusu talep süresi dolmuştur.",
    "2720": "Ödeme hizmetine bağlantı kurulamıyor. Lütfen destek ekibiyle iletişime geçin.",
    "2721": "Bu ödeme hizmeti şu anda kullanılamıyor. Lütfen destek ekibiyle iletişime geçin.",
    "2722": "Bu ödeme hizmeti henüz kullanıma hazır değil. Lütfen destek ekibiyle iletişime geçin.",
    "2723": "Ödeme hizmeti talebi doğrulayamadı. Lütfen destek ekibiyle iletişime geçin.",
    "2724": "Ödeme talebindeki bilgiler geçersiz. Lütfen bilgilerinizi kontrol edin.",
    "2725": "Ödeme tutarını tam TL olarak girin.",
    "2726": "Ödeme tutarı izin verilen alt ve üst sınırların dışında.",
    "2727": "Çekim için geçerli bir IBAN girin.",
    "2728": "Seçilen ödeme yöntemi bulunamadı. Lütfen destek ekibiyle iletişime geçin.",
    "2729": "Seçilen ödeme yöntemi bu sitede kullanılamıyor.",
    "2730": "Seçilen ödeme yöntemi şu anda aktif değil.",
    "2731": "Bu ödeme yöntemiyle yatırım yapılamıyor.",
    "2732": "Bu ödeme yöntemiyle çekim yapılamıyor.",
    "2733": "Bu ödeme yöntemi desteklenmiyor.",
    "2734": "Bu ödeme yöntemi çekim işlemini desteklemiyor.",
    "2735": "Bu ödeme yöntemi doğrudan banka bilgisiyle yatırımı desteklemiyor.",
    "2736": "Doğrudan banka bilgisiyle yatırım kullanılamıyor. Ödeme sayfasını kullanın.",
    "2737": "Bu yatırım işlemi zaten sonuçlandı. İşlem geçmişinizi kontrol edin.",
    "2738": "Bu kart yatırımı zaten sonuçlandı. İşlem geçmişinizi kontrol edin.",
    "2739": "Bu çekim işlemi zaten sonuçlandı. İşlem geçmişinizi kontrol edin.",
    "2740": "Ödeme referansı başka bir işlemle çakışıyor. Lütfen destek ekibiyle iletişime geçin.",
    "2741": "Ödeme referansı bir kart işlemiyle çakışıyor. Lütfen destek ekibiyle iletişime geçin.",
    "2742": "Ödeme referansı bir çekim işlemiyle çakışıyor. Lütfen destek ekibiyle iletişime geçin.",
    "2743": "Sonuçlanmamış bir ödeme işleminiz var. Sonuçlanmasını veya süresinin dolmasını bekleyin.",
    "2744": "Ödeme sağlayıcısı şu anda bu çekimi işleyemiyor. Lütfen destek ekibiyle iletişime geçin.",
    "2745": "Ödeme sağlayıcısı hesabınız için işlem yapılmasına izin vermiyor. Lütfen destek ekibiyle iletişime geçin.",
    "2746": "Tutar doğrudan yatırım sınırını aşıyor. Ödeme sayfasını kullanın.",
    "2747": "Şu anda uygun banka hesabı bulunamadı. Lütfen daha sonra tekrar deneyin.",
    "2748": "Ödeme işleminin süresi doldu. Yeni işlem başlatmadan önce işlem geçmişinizi kontrol edin.",
    "2749": "Bu ödeme işlemi artık değiştirilemiyor. İşlem geçmişinizi kontrol edin.",
    "2750": "Bu ödeme için tutar zaten girilmiş. Mevcut işlem üzerinden devam edin.",
    "2751": "Ödeme sağlayıcısı bu işlem kaydını bulamadı. Lütfen destek ekibiyle iletişime geçin.",
    "2752": "Ödeme hizmetinden zamanında yanıt alınamadı. Mevcut işlemin sonucunu kontrol edin.",
    "2753": "Ödeme hizmetine bağlantı kurulamadı. Mevcut işlemin sonucunu kontrol edin.",
    "2754": "Ödeme hizmetinin yanıtı doğrulanamadı. Lütfen destek ekibiyle iletişime geçin.",
    "2755": "Ödeme talebindeki bilgiler geçersiz. Lütfen bilgilerinizi kontrol edin.",
    "2756": "Bu ödeme hizmeti henüz kullanıma hazır değil. Lütfen destek ekibiyle iletişime geçin.",
    "2757": "Ödeme hizmetinin adresi doğrulanamadı. Lütfen destek ekibiyle iletişime geçin.",
    "2758": "Ödeme sayfasının adresi doğrulanamadı. Lütfen destek ekibiyle iletişime geçin.",
    "2759": "Ödeme hizmetinin işlem bilgileri uyuşmuyor. Lütfen destek ekibiyle iletişime geçin.",
    "2760": "Ödeme hizmeti talebi işleyemedi. Lütfen destek ekibiyle iletişime geçin.",
    "2761": "Bonus kuralları",
    "2762": "Genel kurallar",
    "2763": "Kurallar yükleniyor…",
    "2764": "Genel kurallar şu anda yüklenemiyor. Lütfen tekrar deneyin.",
    "2765": "Çarkı çevir · ##credits## hak",
    "2766": "##credits## çevirme hakkın var",
    "2767": "SPOR YAYINLARI",
    "2768": "MAÇLARI İZLE",
    "2770": "Tam ekran",
    "2771": "Tam ekrandan çık",
    "2772": "Favorilere ekle",
    "2773": "Favorilerden çıkar",
    "2774": "Favorilerim",
    "2775": "Henüz favori oyununuz yok",
    "2776": "Oyun açılıyor…",
    "2777": "Oyunun açılması uzun sürüyor. Lütfen biraz daha bekleyin.",
    "2778": "Favoriler bu tarayıcıda, siteye ve oyuncuya özel saklanır.",
    "2779": "Oyun ekranı",
    "2781": "Yeni sekme açılamadı. Tarayıcınızda açılır pencerelere izin verip tekrar deneyin.",
    "2782": "Oyun alanı çok küçük. Alanı büyüttüğünüzde oyun otomatik olarak yeniden başlayacak.",
    "2800": "AI Asistan",
    "2801": "Asistanı aç",
    "2802": "Asistanı kapat",
    "2803": "Küçült",
    "2804": "Bilgi",
    "2805": "Ayarlar",
    "2806": "Merhaba, seni dinliyorum.",
    "2807": "Nasıl yardımcı olabilirim?",
    "2808": "Gönder",
    "2809": "Hemen Başlat",
    "2810": "ya da",
    "2811": "Neler yapabilirim?",
    "2812": "Bonus",
    "2813": "Finansal",
    "2814": "Oyunlar",
    "2815": "Hesap",
    "2816": "Yardım Merkezi",
    "2817": "Oyun ara",
    "2818": "Kampanyalar",
    "2819": "Para yatır",
    "2820": "Para çek",
    "2821": "Bonuslarım",
    "2822": "İşlem geçmişim",
    "2823": "Hesabım",
    "2824": "Güvenlik",
    "2825": "Yeni sohbet",
    "2826": "Yanıt hazırlanıyor…",
    "2827": "Yanıt alınamadı. Tekrar deneyebilirsin.",
    "2828": "Tekrar dene",
    "2829": "Sohbet şu anda kullanılamıyor. Aşağıdaki menülerden devam edebilirsin.",
    "2830": "Mesajını yaz",
    "2831": "Sohbet geçmişi yalnızca bu sayfa oturumunda tutulur.",
    "2832": "Hesabınla ilgili işlemler mevcut güvenli ekranlarda tamamlanır.",
    "2833": "Genel sorular için giriş yapman gerekmez.",
    "2834": "Tamam",
    "2835": "Merhaba, ne zaman istersen buradayım.",
    "2836": "Sohbeti aç",
    "2837": "##count## / 1000 karakter",
    "2838": "Mesajlar",
    "2839": "Kişisel bilgi veya şifreni sohbete yazma.",
    "2840": "Para işlemlerini sen onaylarsın.",
    "2841": "Mesaj sınırına ulaştın.",
    "2842": "Sohbet",
    "2843": "##count## yanıt hakkı",
    "2844": "Bakiyem",
    "2845": "Bakiye",
    "2846": "Bonus bakiyesi",
    "2847": "Son işlemler",
    "2848": "Aktif bonuslar",
    "2849": "Bilgiler yükleniyor…",
    "2850": "Bilgiler alınamadı.",
    "2851": "Kayıt bulunamadı.",
    "2852": "Bu bilgiler yapay zekâ servisine gönderilmez.",
    "2853": "Güncellenme",
    "2854": "Durum",
    "2855": "Tutar",
    "2856": "Tarih",
    "2857": "Sohbet mesajların DeepSeek’e iletilir. Hesap kartların paylaşılmaz.",
} as const;

export default tr;
